// extracted by mini-css-extract-plugin
export default {"bar":"AnnouncementBar_bar__P3idl","inner":"AnnouncementBar_inner__bA+Lp","text":"AnnouncementBar_text__wyNsH","phone":"AnnouncementBar_phone__WhqVp"};